export default {
    init() {},
    finalize() {
        var state_dropdown = jQuery('#state').parent();
        if (state_dropdown.find('li.selected').length == 0) {
            console.log(state_dropdown.find('li'));
            state_dropdown
                .find('li')
                .first()
                .addClass('selected');
                state_dropdown.find('select').val(state_dropdown.find('select option:first').val());
        }
    }
}

